import { useEffect } from 'react'
import { useGetQuery } from '../useGetQuery'

export const useWeather = ({ lat, lng } = {}) => {
  const { data, isFetching, refetch, setPath, setEnabled } = useGetQuery({
    enabled: !!(lat && lng),
    url: lat && lng ? `/weather/${lat}/${lng}` : ''
  })

  useEffect(() => {
    if (!lat || !lng) return
    setEnabled(true)
    setPath(`/weather/${lat}/${lng}`)
  }, [lat, lng])

  return { weather: data, isFetching, refetch }
}
